import { useState, useEffect, lazy, Suspense, useTransition,useLayoutEffect } from "react"
import { useNavigate } from 'react-router-dom';
import { lang, page_url, chk_img } from '../components/lang'
import { FaSearch } from "react-icons/fa";
import Preloader from '../components/Template/Preloader'
import api from '../components/api'
import styles from '../assets/css/home.module.css';

import Slide from '../components/Homepage/Slide'
import Resource from '../components/Homepage/Resource'
import EBook from '../components/Homepage/Ebook'
import News from '../components/Homepage/News'
import HomeCalendar from '../components/Homepage/HomeCalendar'
// import Activity from '../components/Homepage/Activity'
import Courses from '../components/Homepage/OnlineCourses'

// const Slide = lazy(() => import ('../components/Homepage/Slide'))
// const Resource = lazy(() => import ('../components/Homepage/Resource'))
// const EBook = lazy(() => import ('../components/Homepage/Ebook'))
// const News = lazy(() => import ('../components/Homepage/News'))
// const HomeCalendar = lazy(() => import ('../components/Homepage/HomeCalendar'))
// const Activity = lazy(() => import ('../components/Homepage/Activity'))

function useWindowSize() {
    const [size, setSize] = useState([0, 0]);
    useLayoutEffect(() => {
      function updateSize() {
        setSize([window.innerWidth, window.innerHeight]);
      }
      window.addEventListener('resize', updateSize);
      updateSize();
      return () => window.removeEventListener('resize', updateSize);
    }, []);
    return size;
}

export default function Home() {
    const [init, setInit] = useState([]);
	const navigate = useNavigate();
    const [book_style, setBookStyle] = useState({});
    const [news_style, setNewsStyle] = useState({});
    const [ads_image, setAdsImage] = useState(null);
    const [ads_url, setAdsUrl] = useState("");
    const [ads_title, setAdsTitle] = useState("");
    const [activity_style, setActivityStyle] = useState({});
    const [calendar_style, setCalendarStyle] = useState({});
    const [course_style, setCourseStyle] = useState({});
    // const [width, height] = useWindowSize();
    // const [isAdmin, setIsAdmin] = useState(false);
    // const [isPending, startTransition] = useTransition();

    const [search_type, setSearchType] = useState('discovery');
    const [keyword, setKeyword] = useState('');

    reveal();
    useEffect(()=>{
        const fetchInit = async () =>{
            try {
                const response = await api.get('/setting');
                setInit(response.data.results);
            } catch (err) {
                if(err.response){
                    //Not in 202 response range
                    console.log(err.response.data);
                    console.log(err.response.headers);
                    console.log(err.response.status);
                } else {
                    console.log(`Error: ${err.message}`);
                }
            }
            try {
                const response = await api.get('/article/1');
                const article = response.data.results;
                const detail = JSON.parse(article.detail);
                // console.log(detail);
                let book = {"background":detail.book_color}
                if(detail.book_bg){
                    book["backgroundImage"] = `url(${chk_img(detail.book_bg)})`;
                }
                setBookStyle(book);
                let news = {"background":detail.news_color}
                if(detail.news_bg){
                    news["backgroundImage"] = `url(${chk_img(detail.news_bg)})`;
                }
                setNewsStyle(news);
                let activity = {"background":detail.activity_color}
                if(detail.activity_bg){
                    activity["backgroundImage"] = `url(${chk_img(detail.activity_bg)})`;
                }
                setActivityStyle(activity);
                let calendar = {"background":detail.calendar_color}
                if(detail.calendar_bg){
                    calendar["backgroundImage"] = `url(${chk_img(detail.calendar_bg)})`;
                }
                setCalendarStyle(calendar);
                let oc = {"background":detail.course_color}
                if(detail.course_bg){
                    oc["backgroundImage"] = `url(${chk_img(detail.course_bg)})`;
                }
                setCourseStyle(oc);

                if(detail.ads_img){
                    setAdsImage(chk_img(detail.ads_img));
                    setAdsUrl(detail.ads_url);
                    setAdsTitle(detail.ads_title);
                }
            } catch (err) {
                if(err.response){
                    //Not in 202 response range
                    console.log(err.response.data);
                    console.log(err.response.headers);
                    console.log(err.response.status);
                } else {
                    console.log(`Error: ${err.message}`);
                }
            }
        }
        fetchInit();
        window.addEventListener("scroll", reveal);
        reveal();
    },[]);

    function reveal() {
        var reveals = document.querySelectorAll(".reveal");
        for (var i = 0; i < reveals.length; i++) {
          var windowHeight = window.innerHeight;
          var elementTop = reveals[i].getBoundingClientRect().top;
          var elementVisible = 150;
          if (elementTop < windowHeight - elementVisible) {
            reveals[i].classList.add("active");
          } else {
            reveals[i].classList.remove("active");
          }
        }
    }

    const handleSearch = () => {
        // e.preventDefault();
        // if(search_type==='OPAC'){
        //     window.open("https://search.lib.cmu.ac.th/search/?searchtype=Y&searcharg="+keyword, "_blank");
        if(search_type==='discovery'){
            window.open("https://cmul.primo.exlibrisgroup.com/discovery/search?query=any,contains,"+keyword+"&tab=MainLibrary&search_scope=MainLibrary&vid=66CMU_INST:cmul&offset=0", "_blank");
        }else if(search_type==='Worldwide Search & Request'){
            window.open("https://cmu.on.worldcat.org/external-search?queryString="+keyword+"&lang=th&clusterResults=on&stickyFacetsChecked=on", "_blank");
        }else if(search_type==='EDS'){
            window.open("https://discovery.ebsco.com/c/n2jqxu/results?q="+keyword, "_blank");
        }else if(search_type==='PULINET'){
            window.open("https://search.ebscohost.com/login.aspx?bquery="+keyword+"&submit=Search&direct=true&scope=site&site=eds-live&authtype=ip%2Cguest&custid=s5150876&groupid=main&profile=ill&defaultdb=&option=1", "_blank");
        }else if(search_type==='CMU Intellectual Repository'){
            window.open("http://cmuir.cmu.ac.th/simple-search?query="+keyword, "_blank");
        }else if(search_type==='search website'){
            window.location = page_url+"books?keyword="+keyword;
        }
    }

    const handleKeyDown = (event) => {
        if (event.key === 'Enter') {
            handleSearch();
        }
    }

    return (
        <>
            <div className="homepage">
                {/* <Suspense fallback={<Preloader text="Slide" />}> */}
                    <div className="main-slide container">
                        <Slide styles={styles} />
                    </div>
                {/* </Suspense> */}
                <section className="container">
                    <div className={styles["search-modal"]}>
                        <h5>{lang('สืบค้นข้อมูล :','Search :')}</h5>
                        <fieldset>
                            <select name="search_type" id="search_type" value={search_type} onChange={e=>setSearchType(e.target.value)}>
                                <option value="discovery">PRIMO</option>
                                <option value="Worldwide Search & Request">Worldwide Search & Request</option>
                                <option value="EDS">EDS</option>
                                <option value="PULINET">PULINET</option>
                                {/* <option value="Digital Collections">Digital Collections</option> */}
                                <option value="CMU Intellectual Repository">CMU Intellectual Repository</option>
                                <option value="search website">{lang('ค้นหาภายในเว็บ','Search in Website')}</option>
                            </select>
                            <input type="text" name="keyword" id="keyword" value={keyword} onChange={e=>setKeyword(e.target.value)} onKeyDown={handleKeyDown} placeholder={lang('ค้นหาหนังสือ อีบุ๊ค วารสาร บทความ วิทยานิพนธ์ และ ILL','Find books, e-Books, Journals, articles, dissertations and ILL')} />
                            <button type="button" onClick={e=>handleSearch()}><FaSearch /> {lang('ค้นหา','Search')}</button>
                            <button className={styles["mobile-input"]} type="button" onClick={e=>handleSearch()}><FaSearch /> {lang('ค้นหา','Search')}</button>
                        </fieldset>
                    </div>
                </section>
                {ads_image && (
                    <section className="ads container reveal">
                        <a href={ads_url} target="_blank" rel="noopener noreferrer">
                            <img src={ads_image} alt={ads_title} />
                        </a>
                    </section>
                )}
                {/* 
                <Suspense fallback={<Preloader text="Resource" />}> */}
                    <section className="resource reveal">
                        <Resource styles={styles} />
                    </section>
                {/* </Suspense>
                <Suspense fallback={<Preloader text="Book" />}> */}
                    {/* <section className="book reveal" style={book_style}> */}
                    <section className="book reveal">
                        <EBook styles={styles} />
                    </section>
                {/* </Suspense> */}
                {/* <Suspense fallback={<h1>News Loading</h1>}> */}
                    <section className="courses activity reveal" style={course_style}>
                        <Courses styles={styles} />
                    </section>
                {/* </Suspense> */}
                {/* <Suspense fallback={<Preloader text="Activity" />}> */}
                    {/* <section className="activity reveal" style={activity_style}> */}
                    <section className="news reveal" style={activity_style}>
                        <News styles={styles} />
                    </section>
                {/* </Suspense>
                <Suspense fallback={<Preloader text="Calendar" />}> */}
                    <section className="calendar"style={calendar_style}>
                        <HomeCalendar styles={styles} init={init} />
                    </section>
                {/* </Suspense> */}
            </div>
        </>
    )
}